"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Broadcast/CampaignPage/Body/MessagesTable/ProgressBar/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } }var _react = require('react'); var _react2 = _interopRequireDefault(_react);


var _broadcast = require('shared/enum/broadcast');
var _broadcast3 = require('shared/selectors/broadcast');
var _hooks = require('web/services/hooks');
var _format = require('web/screens/Broadcast/format');
var _useCampaignSchedule = require('web/screens/Broadcast/useCampaignSchedule'); var _useCampaignSchedule2 = _interopRequireDefault(_useCampaignSchedule);
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);

var _ProgressSection = require('./ProgressSection'); var _ProgressSection2 = _interopRequireDefault(_ProgressSection);





/* Rev 31 v2 frame 9b: once sending has started, the campaign page's progress
 * row above the toolbar ("3 of 8 sent"). The filter moved to the toolbar.
 * Recipients waiting for consent get their own segment and a line under it. */
const ProgressBar = ({ campaignKey }) => {
  const stats = _hooks.useAppSelector.call(void 0, state => _broadcast3.selectCampaignStats.call(void 0, state, campaignKey))
  const total = _hooks.useAppSelector.call(void 0, state => _broadcast3.selectCampaignTotalPatientsCount.call(void 0, state, campaignKey))
  const schedule = _useCampaignSchedule2.default.call(void 0, campaignKey)
  const waiting = _nullishCoalesce(stats.awaiting_consent, () => ( 0))
  if (!total) return null

  const bar = (
    _react2.default.createElement('div', { className: "broadcast--progress-bar--wrapper recipients-progress" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 28}}
      , _react2.default.createElement('div', { className: "broadcast--progress-bar--track", 'aria-hidden': true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 29}}
        , _react2.default.createElement(_ProgressSection2.default, { count: stats.completed, totalCount: total, type: _broadcast.broadcastMsgStatus.COMPLETED, __self: this, __source: {fileName: _jsxFileName, lineNumber: 30}} )
        , _react2.default.createElement(_ProgressSection2.default, { count: stats.failed, totalCount: total, type: _broadcast.broadcastMsgStatus.FAILED, __self: this, __source: {fileName: _jsxFileName, lineNumber: 31}} )
        , _react2.default.createElement(_ProgressSection2.default, { count: stats.processing, totalCount: total, type: _broadcast.broadcastMsgStatus.PROCESSING, __self: this, __source: {fileName: _jsxFileName, lineNumber: 32}} )
        , _react2.default.createElement(_ProgressSection2.default, {
          count: stats.queued,
          totalCount: total,
          type: _broadcast.broadcastMsgStatus.QUEUED,
          label: schedule.startAt
            ? `scheduled · starts ${_format.formatSendTime.call(void 0, schedule.startAt, { weekday: true })}`
            : undefined,
          className: _classBuilder2.default.call(void 0, !!schedule.state && 'broadcast--progress-bar--scheduled'), __self: this, __source: {fileName: _jsxFileName, lineNumber: 33}}
        )
        , _react2.default.createElement(_ProgressSection2.default, { count: stats.not_scheduled, totalCount: total, type: _broadcast.broadcastMsgStatus.NOT_SCHEDULED, __self: this, __source: {fileName: _jsxFileName, lineNumber: 42}} )
        , _react2.default.createElement(_ProgressSection2.default, { count: waiting, totalCount: total, type: _broadcast.broadcastMsgStatus.AWAITING_CONSENT, __self: this, __source: {fileName: _jsxFileName, lineNumber: 43}} )
      )
      , _react2.default.createElement('span', { className: "recipients-progress--label", __self: this, __source: {fileName: _jsxFileName, lineNumber: 45}}
        ,  _format.formatCount.call(void 0, stats.completed) , " of "  ,  _format.formatCount.call(void 0, total) , " sent"
      )
    )
  )
  if (!waiting) return bar

  return (
    _react2.default.createElement(_react2.default.Fragment, null
      ,  bar 
      , _react2.default.createElement('p', { className: "recipients-progress--waiting", __self: this, __source: {fileName: _jsxFileName, lineNumber: 55}}
        , _react2.default.createElement('b', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 56}}, "Waiting for consent: "   ,  _format.formatCount.call(void 0, waiting) )
        , _react2.default.createElement('span', { className: "recipients-progress--sep", __self: this, __source: {fileName: _jsxFileName, lineNumber: 57}}, " · "  ), "BloomText texted each one the consent request. They get this message when they reply YES."

      )
    )
  )
}

exports. default = _react.memo.call(void 0, ProgressBar)
